import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Modal, Form } from "react-bootstrap";
import { ButtonComponent, AnchorComponent } from "../elements";
import Swal from 'sweetalert2';
import {enviarPassword, actualizarUsuarios, listadoUsuarios} from "../../api/usuarios.api.ts";

export default function UsersTableComponent({ thead, tbody, onUserUpdate }) {

    const { t } = useContext(TranslatorContext)

    const [data, setData] = useState([]);
    const [userData, setUserData] = React.useState("");
    const [editModal, setEditModal] = React.useState(false);
     const [editModalPassword, setEditModalPassword] = React.useState(false);
    const [blockModal, setBlockModal] = React.useState(false);
    const [rutError, setRutError] = React.useState("");

    // Función para validar RUT
    const Fn = {
        validaRut: function (rutCompleto) {
            rutCompleto = rutCompleto.replace(/^0+|[^0-9kK-]+/g, '');
            if (!/^[0-9]+-[0-9kK]{1}$/.test(rutCompleto)) return false;
            const tmp = rutCompleto.split('-');
            const digv = tmp[1].toLowerCase();
            const rut = tmp[0];
            return (Fn.dv(rut) === digv);
        },
        dv: function (T) {
            let M = 0, S = 1;
            for (; T; T = Math.floor(T / 10)) {
                S = (S + T % 10 * (9 - M++ % 6)) % 11;
            }
            return S ? String(S - 1) : 'k';
        }
    };

    const handleRutBlur = () => {
        if (!userData?.usu_rut || !userData?.usu_dv) {
            setRutError("Debe ingresar un RUT válido");
            return;
        }

        const rutFormato = formatearRutConDv(userData.usu_rut, userData.usu_dv);
        
        if (Fn.validaRut(rutFormato)) {
            setRutError("");
        } else {
            setRutError("RUT inválido. Verifique el dígito verificador");
        }
    };

    useEffect(()=> { setData(tbody) }, [tbody]);

    const handleSendPlassword = async (idUsuario) => {
            // Lógica para procesar el pago
            setEditModalPassword(false);
            Swal.fire({
                title: "Enviado Nuevo Password",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });
             
             enviarPassword(idUsuario).then(async (res) => {
                Swal.close();
                
                 
                
                Swal.fire({
                    icon: 'success',
                    text: 'El envio de la nueva password fue existosa.'
                });
            }
            );
    
        };

     const handleEditUser = () => {
        // Validar RUT antes de actualizar
        if (!userData?.usu_rut || !userData?.usu_dv) {
            setRutError("Debe ingresar un RUT válido");
            return;
        }

        const rutFormato = formatearRutConDv(userData.usu_rut, userData.usu_dv);
        
        if (!Fn.validaRut(rutFormato)) {
            setRutError("RUT inválido. Verifique el dígito verificador");
            return;
        }

        // Si el RUT es válido, proceder con la actualización
        setRutError("");
        setEditModal(false);
        Swal.fire({
                title: "Actualizando Usuario",
                text: "Por favor, espere...",
                allowOutsideClick: false,
                didOpen: () => {
                  Swal.showLoading();
                }
              });
             
             actualizarUsuarios(userData).then(async (res) => {
                Swal.close();
                
                // Verificar si hay error en la respuesta
                if (res.error) {
                    setEditModal(true);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: res.msg || 'Ocurrió un error al actualizar el usuario'
                    });
                    return;
                }

                Swal.fire({
                    icon: 'success',
                    text: 'Usuario actualizado.'
                });
                const response = await listadoUsuarios();
                // Usar el callback para actualizar la lista en el componente padre
                if (onUserUpdate) {
                    onUserUpdate(response.usuarios);
                } else {
                    // Fallback para mantener compatibilidad
                    setData(response.usuarios);
                }
            }).catch((error) => {
                Swal.close();
                setEditModal(true);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.message || 'Error al actualizar el usuario'
                });
            });
    
    };   

    const formatearRutConDv = (rut, dv) => {
        if (!rut) return "";
        
        // Si rut es un string, elimina puntos y guiones
        let rutStr = rut.toString().replace(/[\.\-]/g, "");
        
        // Si se pasó un dv específico, úsalo; si no, toma el último carácter de rutStr si tiene más de 8 dígitos
        let digitoVerificador = dv || "";
        if ((!dv || dv === "") && rutStr.length > 8) {
            // Si no hay DV y el RUT tiene más de 8 dígitos, el último es el DV
            digitoVerificador = rutStr.charAt(rutStr.length - 1);
            rutStr = rutStr.slice(0, -1);
        }
        
        // Formatea el RUT con puntos cada 3 dígitos desde la derecha
        rutStr = rutStr.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        
        return `${rutStr}-${digitoVerificador}`;
    }

    return (
        <div className="mc-table-responsive">
            <table className="mc-table">
                <thead className="mc-table-head primary">
                    <tr>
                        <th>
                            <div className="mc-table-check">
                               
                                <p>uid</p>
                            </div>
                        </th>
                        {thead.map((item, index) => (
                            <th key={ index }>{ item }</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data?.map((item, index) => (
                        <tr key={ index }> 
                            <td title="id">
                                <div className="mc-table-check">
                                    
                                    <p>#{item.usu_id }</p>
                                </div>
                            </td>
                            <td title={ item.usu_nombre }>
                                <div className="mc-table-profile">
                                    
                                    <p>{ item.usu_nombre }</p>
                                </div>
                            </td>
                            <td title={ item.usu_apellido }>
                                <div className="mc-table-icon role">
                                   
                                    <span>{ item.usu_apellido }</span>
                                </div>
                            </td>
                            <td title={ formatearRutConDv(item.usu_rut, item.usu_dv) }>{ formatearRutConDv(item.usu_rut, item.usu_dv) }</td>
                            <td title={ item.usu_email }>{ item.usu_email }</td>
                          
                            <td title={ item.usu_activo.data[0] }>
                                { item.usu_activo.data[0] === 1 && <p className="mc-table-badge green">Activo</p> }
                                { item.usu_activo === "pending" && <p className="mc-table-badge purple">{ item.status }</p> }
                                { item.usu_activo.data[0] !== 1 && <p className="mc-table-badge red">Desactivado</p> }
                            </td>
                            <td title={ item.usu_fcreacion }>{ item.usu_fcreacion }</td>
                            <td>
                                <div className="mc-table-action">
                                   <ButtonComponent title="Edit" className="material-icons view" onClick={()=> setEditModalPassword(true, setUserData(item))}>lock</ButtonComponent>
                                    <ButtonComponent title="Edit" className="material-icons edit" onClick={()=> setEditModal(true, setUserData(item))}>edit</ButtonComponent>
                                   
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

               <Modal show={ editModalPassword } onHide={()=> {
                setEditModalPassword(false);
                setUserData("");
                setRutError("");
            }}>
                <div className="mc-user-modal">
                    <img src={ userData.src } alt={ userData?.alt } />
                    <h4>Generar Nuevo Password</h4>
                    <p>Al usuario <b>{userData.usu_nombre} {userData.usu_apellido}</b> se le enviara un nuevo password al email <b>{userData.usu_email}</b></p> 
                    <p>Esta acción eliminara la password actual del usuario</p>
                    <p>¿Desea continuar?</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={()=> setEditModalPassword(false)}>Cancelar</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-success" onClick={()=> handleSendPlassword(userData?.usu_id)}>Aceptar</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>

            <Modal show={ editModal } onHide={()=> {
                setEditModal(false);
                setUserData("");
                setRutError("");
            }}>
                <div className="mc-user-modal">
                    <img src={ userData.src } alt={ userData?.alt } />
                    <h4>{ userData?.name }</h4>
                    <p>{ userData?.email }</p>
                     <Form>
                        <Form.Group className="form-group mb-3">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                type="text"
                                name="usu_nombre"
                                value={userData?.usu_nombre || ""}
                                onChange={e => setUserData({ ...userData, usu_nombre: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="form-group mb-3">
                            <Form.Label>Apellido</Form.Label>
                            <Form.Control
                                type="text"
                                name="usu_apellido"
                                value={userData?.usu_apellido || ""}
                                onChange={e => setUserData({ ...userData, usu_apellido: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="form-group mb-3">
                            <Form.Label>RUT</Form.Label>
                            <Form.Control
                                type="text"
                                name="usu_rut"
                                value={formatearRutConDv(userData?.usu_rut, userData?.usu_dv)}
                                isInvalid={!!rutError}
                                onChange={e => {
                                    const rut = e.target.value;
                                    
                                    // Limpia el RUT eliminando puntos, guiones o espacios
                                    const limpio = rut.replace(/[^0-9kK]/g, '').toUpperCase();
                                    
                                    if (limpio.length < 2) {
                                        setUserData({
                                            ...userData,
                                            usu_rut: limpio,
                                            usu_dv: ""
                                        });
                                        return;
                                    }

                                    const cuerpo = limpio.slice(0, -1);
                                    const dv = limpio.slice(-1);
                                    
                                    setUserData({
                                        ...userData,
                                        usu_rut: cuerpo,
                                        usu_dv: dv
                                    });
                                }}
                                onBlur={handleRutBlur}
                                maxLength={12}
                            />
                            {rutError && <Form.Control.Feedback type="invalid">{rutError}</Form.Control.Feedback>}
                        </Form.Group>
                        <Form.Group className="form-group mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name="usu_email"
                                value={userData?.usu_email || ""}
                                onChange={e => setUserData({ ...userData, usu_email: e.target.value })}
                            />
                        </Form.Group>
                        
                        <Form.Group className="form-group mb-3">
                            <Form.Label>Estado</Form.Label>
                            <Form.Select
                                name="usu_activo"
                                value={userData?.usu_activo?.data ? userData.usu_activo.data[0] : ""}
                                onChange={e => setUserData({ ...userData, usu_activo: { data: [parseInt(e.target.value)] } })}
                            >
                                <option value="1">Activo</option>
                                <option value="0">Desactivado</option>
                            </Form.Select>
                        </Form.Group>
                    </Form>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={()=> setEditModal(false)}>Cancelar</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-success" onClick={()=> handleEditUser()}>Actualizar</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
            
            <Modal show={ blockModal } onHide={()=> setBlockModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>are your sure!</h3>
                    <p>Want to block this user's account?</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={()=> setBlockModal(false)}>{t('close')}</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={()=> setBlockModal(false)}>{t('block')}</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    )
}